import { values } from './enums'

const DueDateWeekly = {
  WEEK_DAY: 0,
  OFFSET: 1
}

const VALUES = values(DueDateWeekly)

export {
  DueDateWeekly,
  VALUES
}



// WEBPACK FOOTER //
// ./src/enums/DueDateWeekly.js